export const LayoutDefaults = {
    headerHeight: 61,
    leftSidebarWidth: 300,
    rightSidebarWidth: 300,
}